var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse118(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.393519 4.3934C2.49131 2.29561 5.16405 0.866999 8.07377 0.288221C10.9835 -0.290558 13.9995 0.00649267 16.7404 1.14181C19.4813 2.27712 21.8239 4.19971 23.4722 6.66645C25.1204 9.13319 26.0001 12.0333 26.0001 15C26.0001 17.9667 25.1204 20.8668 23.4722 23.3336C21.8239 25.8003 19.4813 27.7229 16.7404 28.8582C13.9995 29.9935 10.9835 30.2906 8.07376 29.7118C5.16404 29.133 2.4913 27.7044 0.393513 25.6066L11.0001 15L0.393519 4.3934Z",
    fill: "#F7722D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse118);
export default __webpack_public_path__ + "static/media/Ellipse 118.c32ca0d7e2dd294492dd51c8274c242d.svg";
export { ForwardRef as ReactComponent };